module.exports = __webpack_public_path__ + "media/images/icons/chat-c06d9957950c402072d7feef013220f8.svg";